import React from "react";
import PropTypes from "prop-types";
import ButtonWithIcon from "components/ButtonWithIcon";

const formatContractorAddress = ({ address, postal_code }) => {
  return `${address}, ${postal_code.postal_code} ${postal_code.city}`;
};

const PickingHeader = ({
  metadataToSynchronize,
  ordersCommentsToSynchronize,
  synchronizePickingLoading,
  synchronizePicking,
  contractor,
}) => {
  const hasChangesToSync =
    metadataToSynchronize.length > 0 || ordersCommentsToSynchronize.length > 0;

  return (
    <div className="picking__header">
      <div className="picking__header-card">
        {/* Store Badge */}
        <div className="picking__store-badge">
          <i className="fa fa-store" aria-hidden="true" />
          <span>MAGASIN</span>
        </div>

        {/* Store Information */}
        <div className="picking__store-info">
          <div className="picking__store-name">
            <span className="picking__label">Magasin:</span>
            <span className="picking__value">{contractor.name}</span>
          </div>
          <div className="picking__store-address">
            <span className="picking__label">Adresse:</span>
            <span className="picking__value">
              {formatContractorAddress(contractor.address)}
            </span>
          </div>
        </div>

        {/* Sync Status and Button */}
        <div className="picking__sync-section">
          {hasChangesToSync && (
            <div className="picking__sync-status">
              <i className="fa fa-exclamation-circle" aria-hidden="true" />
              <span>Modifications non synchronisées</span>
            </div>
          )}
          <div className="picking__sync-button">
            <ButtonWithIcon
              disabled={!hasChangesToSync || synchronizePickingLoading}
              icon="sync-alt"
              onClick={synchronizePicking}
            >
              Synchroniser
            </ButtonWithIcon>
          </div>
        </div>
      </div>
    </div>
  );
};

PickingHeader.propTypes = {
  contractor: PropTypes.shape({
    address: PropTypes.shape({
      address: PropTypes.string.isRequired,
      postal_code: PropTypes.shape({
        postal_code: PropTypes.string.isRequired,
        city: PropTypes.string.isRequired,
      }),
    }).isRequired,
    name: PropTypes.string.isRequired,
  }),
  metadataToSynchronize: PropTypes.array.isRequired,
  ordersCommentsToSynchronize: PropTypes.array.isRequired,
  synchronizePicking: PropTypes.func.isRequired,
  synchronizePickingLoading: PropTypes.bool.isRequired,
};

export default PickingHeader;
